/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import { RootState } from "..";

export const selectMachineProcessUpdates = (state: RootState) =>
  state.processUpdates.groupedTableData.machine;

export const selectJobProcessUpdates = (state: RootState) =>
  state.processUpdates.groupedTableData.job;

export const selectCharacteristicProcessUpdates = (state: RootState) =>
  state.processUpdates.groupedTableData.characteristic;

export const selectCharacteristicExpandCollapseState = (state: RootState) =>
  state.processUpdates.expandCollapseState.characteristic;

export const selectJobExpandCollapseState = (state: RootState) =>
  state.processUpdates.expandCollapseState.job;

export const selectMachineExpandCollapseState = (state: RootState) =>
  state.processUpdates.expandCollapseState.machine;

export const selectJobDetailViewState = (state: RootState) =>
  state.processUpdates.expandCollapseState.job.openDetailsList;

export const selectMachineDetailViewState = (state: RootState) =>
  state.processUpdates.expandCollapseState.machine.openDetailsList;

export const selectCharacteristicDetailViewState = (state: RootState) =>
  state.processUpdates.expandCollapseState.characteristic.openDetailsList;

export const selectLastFetchedForRefresh = (s: RootState) =>
  s.processUpdates.lastFetchedForRefresh;
